import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared/shared.module';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { FormWidgetAvvComponent } from '@modules/bcm/@work-flows/@form-widgets/core/avv/form-widget-avv.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

@NgModule({
    declarations: [FormWidgetAvvComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatCheckboxModule,

        SignaturePadModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatInputModule
    ],
    exports: [FormWidgetAvvComponent]
})
export class FormWidgetAvvModule {
    
}
